"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollableContent = exports.BodyCell = exports.HeaderCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var VALUE = _constants.VALUE_KEYS.VALUE,
    PERCENT = _constants.VALUE_KEYS.PERCENT;

var renderValue = function renderValue(props) {
  //label and cell formatters
  var isTotal = props.isTotal,
      isLabel = props.isLabel,
      isDate = props.isDate,
      valueType = props.valueType,
      formatter = props.formatter;

  if (typeof formatter === 'function') {
    var _formatter = props.formatter,
        rest = _objectWithoutProperties(props, ["formatter"]);

    return _formatter(rest);
  }

  return isTotal || isLabel || isDate ? props[VALUE] : valueType === PERCENT ? "".concat(props[PERCENT], " %") : props[VALUE];
};

var renderHeader = function renderHeader(props) {
  //header formatter
  var formatter = props.formatter,
      label = props.label;

  if (typeof formatter === 'function') {
    var _formatter2 = props.formatter,
        rest = _objectWithoutProperties(props, ["formatter"]);

    return _formatter2(rest);
  }

  return label;
};

var HeaderCell = function HeaderCell(props) {
  return _react.default.createElement("div", {
    style: _objectSpread({}, (0, _styles.tableCell)(props.tableCellStyles), {
      backgroundColor: props.color
    }, props.style)
  }, _react.default.createElement("p", {
    style: (0, _styles.headerLabel)(props.headerLabelStyles)
  }, renderHeader(props)), props.showHeaderValues ? _react.default.createElement("span", {
    style: (0, _styles.headerValue)({})
  }, renderValue(_objectSpread({}, props, {
    isHeaderValue: true
  }))) : null);
};

exports.HeaderCell = HeaderCell;

var BodyCell = function BodyCell(props) {
  return _react.default.createElement("div", {
    style: _objectSpread({}, (0, _styles.tableCell)(props.tableCellStyles), {
      backgroundColor: props.color
    }, props.style),
    title: "Out of ".concat(props.total, " on ").concat(props.valueFor)
  }, renderValue(props));
};

exports.BodyCell = BodyCell;

var ScrollableContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ScrollableContent, _React$Component);

  function ScrollableContent(props) {
    var _this;

    _classCallCheck(this, ScrollableContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollableContent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "setWidth", function () {
      if (_this.ref && _this.ref.parentNode) {
        try {
          _this.setState({
            width: _this.ref.parentNode.clientWidth - 1
          });
        } catch (e) {//console.error(e);
        }
      }
    });

    _this.state = {
      width: 0
    };
    _this.ref = null;
    return _this;
  }

  _createClass(ScrollableContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setWidth();
      window.addEventListener('resize', function () {
        _this2.setWidth();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var scrollableTableContentStyles = this.props.scrollableTableContentStyles;
      return _react.default.createElement("div", {
        ref: function ref(x) {
          return _this3.ref = x;
        },
        style: _objectSpread({}, (0, _styles.scrollableTableContent)(scrollableTableContentStyles), {
          width: this.state.width
        })
      }, this.props.children);
    }
  }]);

  return ScrollableContent;
}(_react.default.Component);

exports.ScrollableContent = ScrollableContent;